import { Directive, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  selector: '[appSort]',
  standalone: true})
export class SortDirective implements OnChanges, OnDestroy {
  @Input() predicate: string;
  @Input() ascending: boolean;
  @Input() callback?: () => void;
  @Input() defaultPredicate = 'id';
  @Output() predicateChange = new EventEmitter<string>();
  @Output() ascendingChange = new EventEmitter<boolean>();

  readonly sortChange = new Subject<void>();

  ngOnChanges(): void {
    this.sortChange.next();
  }

  ngOnDestroy(): void {
    this.sortChange.complete();
  }

  sort(field: string): void {
    if (this.predicate !== field) {
      this.predicate = field;
      this.ascending = true;
    } else if (this.ascending) {
      this.ascending = false;
    } else {
      this.predicate = this.defaultPredicate;
      this.ascending = true;
    }

    this.predicateChange.emit(this.predicate);
    this.ascendingChange.emit(this.ascending);
    this.sortChange.next();

    if (this.callback) {
      this.callback();
    }
  }
}
